import React from 'react';
import { FormattedNumber } from 'react-intl';


const CHEQUING_MONTHLY_BALANCES = [
    500,
    1_000,
    5_000,
    10_000,
    50_000,
];

const CHEQUING_MONTHLY_BALANCES_OPTIONS = Object.values(CHEQUING_MONTHLY_BALANCES).map(value => ({
    value: value,
    label: (
        <FormattedNumber
            value={value}
            format="CAD0"
            minimumFractionDigits={0}
            maximumFractionDigits={0}
        />
    ),
}));


export { CHEQUING_MONTHLY_BALANCES };
export default CHEQUING_MONTHLY_BALANCES_OPTIONS;
